export default __webpack_public_path__ + "static/Ulm-Grotesk-Bold-1a5719e5eccf5bf30b9d32c5628da655.otf";